import React from 'react'
import { URL_REPLACE } from "../../Common/RegExValidate"
import { encryptID } from '../../HotelPage/hotelServices'

const EstablishmentName = ({
  establishment,
  establishmentId,
  pricelineId,
  setHotelEstablishmentId, // optional, not used here
  establishmentName,
  divClass = "",
  establishmentCity = "",
  establishmentState = "",
  establishmentCountry = "",
  titleClass,
  titleStyle,
  ppn_bundle,
  lang,
  hotel_form_state, // may be undefined!
}) => {
  // Safe helpers
  const str = (v, d = "") => (v == null ? d : String(v))
  const int = (v, d = 0) => (Number.isFinite(Number(v)) ? Number(v) : d)
  const slug = (v, d = "") => str(v, d).replace(URL_REPLACE, "_")

  // Name & location slugs
  const nameSlug = slug(establishmentName, "hotel")
  const citySlug = establishmentCity ? "_" + slug(establishmentCity) : ""
  const stateSlug = establishmentState ? "_" + slug(establishmentState) : ""
  const countrySlug = establishmentCountry ? "_" + slug(establishmentCountry) : ""

  // Query-from-URL
  const searchParams = new URLSearchParams(window.location.search.substring(1))
  const promoCode = str(searchParams.get("promo-code") || searchParams.get("PROMO-CODE"))
  const hotelType = establishment?.hotelType

  // Form state (SAFE)
  const hfs = hotel_form_state ?? {}
  const baseQueryParams = new URLSearchParams({
    city_id: str(hfs.city_id),
    check_in: str(hfs.check_in),
    check_out: str(hfs.check_out),
    rooms: String(int(hfs.rooms, 1)),
    guests: String(int(hfs.adults, 1)),
    city_lat: str(hfs.city_latitude),
    city_lng: str(hfs.city_longitude),
    ppn_bundle: str(ppn_bundle, ""),
    where: slug(hfs.where),
  }).toString()

  const go = (url) => window.open(url, "_blank", "noopener,noreferrer")

  const handleClick = () => {
    try {
      // Prefer explicit props, then establishment fields
      const hpExpHotelId = establishment?.establishmentID
      const pricelineHotelId =
        pricelineId ??
        establishment?.establishmentPricelineID ??
        establishment?.establishmentID

      // Minimal guard: if we have NOTHING to navigate to, bail quietly
      if (!pricelineHotelId && !hpExpHotelId) {
        console.warn("[EstablishmentName] No hotel ID available to navigate.")
        return
      }

      // Branches
      if (hotelType === "hp" || hotelType === "exp") {
        // Require establishmentID for these flows
        const hid = hpExpHotelId || pricelineHotelId
        const url =
          `/muv-hotel-${nameSlug}${citySlug}${stateSlug}${countrySlug}-${hid}` +
          `?${baseQueryParams}&findBy=${hotelType}`
        return go(url)
      }

      if (promoCode) {
        // Promo code path uses raw pricelineId (not encrypted)
        const id = pricelineHotelId
        const url =
          `/hotel-${nameSlug}${citySlug}${stateSlug}${countrySlug}-${id}` +
          `?${baseQueryParams}&promo-code=${promoCode}`
        return go(url)
      }

      // Default: encrypted id if available
      const encId = pricelineHotelId ? encryptID(pricelineHotelId) : ""
      const url =
        `/hotel-${nameSlug}${citySlug}${stateSlug}${countrySlug}-${encId}` +
        `?${baseQueryParams}`

      return go(url)
    } catch (err) {
      console.error("[EstablishmentName] Navigation error:", err)
      // Soft fallback: navigate to a safe listing route or do nothing
      // go('/hotels'); // uncomment if you want a fallback redirect
    }
  }

  return (
    <div style={{ display: "inline-block" }} className={divClass}>
      <div style={titleStyle} className={titleClass} onClick={handleClick}>
        {establishmentName ?? "View hotel"}
      </div>
    </div>
  )
}

export default EstablishmentName
